







































import Component, { mixins } from "vue-class-component";
import { Prop } from "vue-property-decorator";
import { User } from "@teacherskaya/api-provider/dist/api/UserProvider";
import { checkAuthorities } from "@teacherskaya/tools/dist/lib/SecurityHelpers";
import { WatchParentResize } from "@/lib/helpers/customDecorators";
import { $t } from "@/lib/helpers/i18nHelper";
import emitter from "@/lib/helpers/emitter";
import config from "@/config";
import WithLoggedInUser from "@/mixins/WithLoggedInUser";
import { menuItems, MenuItem } from "./config";

@WatchParentResize("onResize")
@Component({ name: "ProfileSubMenu" })
export default class ProfileSubMenu extends mixins(WithLoggedInUser) {
  @Prop({ type: Object, required: true })
  public currentUser!: User;

  @Prop({ type: Boolean, default: false })
  public hideDisable!: boolean;

  @Prop({ type: Boolean, default: false })
  public hideDelete!: boolean;

  public parentSize: number = 0;

  public onResize(parentSize: number) {
    this.parentSize = parentSize;
  }

  get menuItems(): MenuItem[] {
    const profileLink = `${config.clientSideUrl}/login?redirectPath=/profile/${this.currentUser.id}`;
    let items = menuItems.map(item => {
      if (item.name === "manageProfile") {
        return {
          ...item,
          to: {
            name: "profile/login",
            params: {
              userId: this.currentUser.id.toString(),
            },
          },
        };
      }
      if (item.name === "changePassword") {
        return { ...item, click: () => emitter.emit("showModalChangePassword") };
      }
      if (item.name === "disable") {
        return {
          ...item,
          text: $t(this.currentUser.accountInfo.disabled ? "Enable" : "Disable"),
          click: () => this.$emit("disableUser"),
        };
      }
      if (item.name === "delete") return { ...item, click: () => this.$emit("deleteUser") };
      return item;
    });
    if (this.hideDisable) {
      items = items.filter(i => i.name !== "disable");
    }
    if (this.hideDelete) {
      items = items.filter(i => i.name !== "delete");
    }
    if (!checkAuthorities(this.loggedInUser.authorities, ["getAnyLongLiveTokenByUser"])) {
      items = items.filter(i => i.name !== "manageProfile");
    }
    return items;
  }

  get menuList() {
    return this.menuItems.filter(i => {
      if (!i.hide || this.parentSize === 0) return true;
      return i.hide < this.parentSize;
    });
  }

  get moreList() {
    return this.menuItems.filter(i => {
      if (!i.hide || this.parentSize === 0) return false;
      return i.hide > this.parentSize;
    });
  }

  get showMore() {
    return this.moreList.length > 0;
  }
}
